export enum SettingUrlType {
    Form = 1, Html, JsFunction, Status, Delete, Component, Widget, Report, App, Dashboard, Dashboardgroup, Procedure

}

export enum SettingType
{
    View = 1, Create, Update, Delete, Manage, Import, Export, Administrate,IncludeShowApp
}
export enum AppProviderType {
    Dependent = 1,
    Premium = 2,
    Setting = 3,
    Report = 4,
    PremiumReport = 5,
    Hidden = 6
}

export enum AppType {
    App = 1,
    Setting = 2,
    Configuration = 3,
    Dev = 4
}

export enum DependentType {
    App = 1,
    Report = 2,
    Widget = 3,
    AppPortlet = 4,
    DashboardPortlet = 5,
    ChildApp = 6
}

export enum PlatformVersion {
    One = 1,
    Two = 2,
    Three = 3
}

export enum SeriesType {
    Alphabets = 1,
    Numbers = 2,
    AlphaNumeric = 3
}

export enum StageRoleType {
    View = 1,
    Change = 2
}
